// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

export class CharacterRect {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): CharacterRect {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  x(): number {
    return this.bb!.readUint16(this.bb_pos)
  }

  y(): number {
    return this.bb!.readUint16(this.bb_pos + 2)
  }

  width(): number {
    return this.bb!.readUint16(this.bb_pos + 4)
  }

  height(): number {
    return this.bb!.readUint16(this.bb_pos + 6)
  }

  static sizeOf(): number {
    return 8
  }

  static createCharacterRect(
    builder: flatbuffers.Builder,
    x: number,
    y: number,
    width: number,
    height: number
  ): flatbuffers.Offset {
    builder.prep(2, 8)
    builder.writeInt16(height)
    builder.writeInt16(width)
    builder.writeInt16(y)
    builder.writeInt16(x)
    return builder.offset()
  }
}
